"use client";

import { useState, useEffect } from "react";
import { Button } from "./ui/button";

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consentGiven = localStorage.getItem("cookieConsent");
    if (consentGiven === null) {
      setShowBanner(true);
      // Prevent scrolling when banner is shown
      document.body.style.overflow = "hidden";
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
    document.body.style.overflow = "auto";
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShowBanner(false);
    document.body.style.overflow = "auto";
  };

  if (!showBanner) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50" style={{ background: "rgba(10, 14, 23, 0.8)" }}>
      <div
        className="p-6 w-full max-w-lg mx-4"
        style={{
          background: "#151D2E",
          border: "1px solid #1E2A3F",
          borderRadius: "20px",
          color: "#F1F5F9",
        }}
      >
        <p className="mb-4 text-sm leading-relaxed" style={{ color: "#8B95A8" }}>
          We use cookies to enhance your browsing experience and analyze our
          traffic. By clicking &quot;Accept&quot;, you consent to our use of
          cookies.
        </p>
        <div className="flex justify-end gap-3">
          <Button
            variant="outline"
            onClick={handleReject}
            className="text-sm font-semibold px-5 py-2 rounded-xl transition-all duration-200"
            style={{
              border: "1.5px solid #19E094",
              color: "#19E094",
              background: "transparent",
            }}
          >
            Reject
          </Button>
          <Button
            onClick={handleAccept}
            className="text-sm font-bold px-5 py-2 rounded-xl transition-all duration-200"
            style={{
              background: "linear-gradient(135deg, #19E094, #0fa968)",
              color: "#0A0E17",
              border: "none",
              boxShadow: "0 4px 16px rgba(25, 224, 148, 0.25)",
            }}
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}